<template>
  <div class="am-backoffice-signup">
    <div class="am-sign-up-form-outer-title-bar">
      <span class="am-sign-up-form-title"><strong>Sign-Up New Agency</strong></span>
    </div>
    <div class="am-sign-up-form">
      <div class="am-sign-up-form-inner-title-bar">
        <span class="am-sign-up-form-title"><strong>Information</strong></span>
      </div>
      <form>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Signup Date:</label>
          <div class="col-sm-10">
            <input type="date" class="form-control" v-model="newForm.date" disabled>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Package:</label>
          <div class="col-sm-10 am-required">
            <select class="form-control" v-model="newForm.packageName">
              <option value='None'>None</option>
              <option v-for="version in versions" :value="version.liteSwitch" :key="version.id">{{version.name}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Representative:</label>
          <div class="col-sm-10 am-required">
            <select class="form-control" v-model="newForm.sales_representative">
              <option value='0'>Select</option>
              <option v-for="salesRep in salesReps" :value="salesRep.id" :key="salesRep.id">{{salesRep.name}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">CRM:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.crm" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Agency Name:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.agency.name" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Address:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.street" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">City:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.city" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">State:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.state" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Zip:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.zipcode" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Contact 1:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.contact1" @keypress="isNumber($event, newForm.owner.contact1)" maxlength="10" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Contact 2:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.contact2" @keypress="isNumber($event, newForm.owner.contact2)" maxlength="10" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Phone:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.primary_phone" @keypress="isNumber($event, newForm.owner.primary_phone)" maxlength="10" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Fax:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.fax" @keypress="isNumber($event, newForm.owner.fax)"  maxlength="10" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Agency Operating Name:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.operatingName" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Agent/Owner:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.name" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Agent/Owner Cell Phone:</label>
          <div class="col-sm-10 am-required">
            <input type="text" v-model="newForm.owner.cell_phone" @keypress="isNumber($event, newForm.owner.cell_phone)" maxlength="10" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Agent/Owner Email:</label>
          <div class="col-sm-10 am-required">
            <input type="email" v-model="newForm.owner.email" class="form-control">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Source:</label>
          <div class="col-sm-10 am-required">
            <select class="form-control" v-model="newForm.referralSource">
              <option value='0'>Select Source</option>
              <option v-for="source in sources" :value="source.id" :key="source.id">{{source.name}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Conversion from:</label>
          <div class="col-sm-10">
            <select class="form-control"v-model="newForm.competitor">
              <option value='0'>-Select Management System-</option>
              <option v-for="competitor in competitors" :value="competitor.id" :key="competitor.id">{{competitor.name}}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Other Instructions:</label>
          <div class="col-sm-10 am-required">
            <textarea class="form-control" v-model="newForm.instructions" maxlength="1000"></textarea>
            <div>Max Character Limit: 1000</div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Training Contact Name:</label>
          <div class="col-sm-10 am-required">
            <input type="text" class="form-control" v-model="newForm.trainingContactName" maxlength="30">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-2 col-form-label">Training Contact Email:</label>
          <div class="col-sm-10 am-required">
            <input type="email" class="form-control" v-model="newForm.trainingContactEmail">
          </div>
        </div>
      </form>
    </div>
    <div class="am-sign-up-form-ribbon-bottom">
      <button class="am-sign-up-form-save-button" @click="onSubmit">
        <img src="@/assets/save.png">
      </button>
    </div>
    <modal name="MessagePopup" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3"  :adaptive="true" width="370px" height="auto">
      <message-popup :confirmDelete="false" :errors="messageString" messageHeader="Error" :isError="true"></message-popup>
    </modal>
  </div>
</template>

<script>
import api from "@/http";
import MessagePopup from '../MessagePopup'
import config from "@/config/global.config";
import hasBackOffice from './../../mixins/helper'

export default {
  name: "SignUp",
  mixins: [hasBackOffice],
  mounted () {
    if(!this.hasBackOffice()){
      window.location =  config.applicationUrl('/#/home');
    }
  },
  data() {
    return {
      masterId: 0,
      newForm: {
        sales_representative: 0,
        packageName: 'None',
        referralSource: 0,
        competitor: 0,
        date: new Date().toISOString().substr(0, 10),
        crm: '',
        operatingName: '',
        instructions: '',
        trainingContactName: '',
        trainingContactEmail: '',
        agency: {
          name: '',
        },
        owner: {
          name: '',
          street: '',
          city: '',
          state: '',
          zipcode: '',
          contact1: '',
          contact2: '',
          primary_phone: '',
          fax: '',
          cell_phone: '',
          email: '',
        }
      },
      packageName: 'None',
      messageString: ''
    }
  },
  asyncComputed: {
    sources: {
      get() {
        return api.makeRequest('/utility/source-list').then(
          (data) => {
            return data.data.results
          }
        )
      }
    },
    versions: {
      get() {
        return api.makeRequest('/utility/backoffice-version').then(
          (data) => {
            return data.data.results
          }
        )
      }
    },
    salesReps: {
      get() {
        return api.makeRequest('/utility/backoffice-salesmen').then(
          (data) => {
            return data.data.results
          }
        )
      }
    },
    competitors: {
      get() {
        return api.makeRequest('/utility/competitor').then(
          (data) => {
            return data.data.results
          }
        )
      }
    }
  },
  components: {
    MessagePopup
  },
  methods: {
    messagePopup: function () {
      this.$modal.show('MessagePopup')
      document.body.style.overflow = "hidden";
    },
    isNumber (event, value) {
      event = (event) || window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault()
      } else if (charCode === 46 && value.includes('.')) {
        event.preventDefault()
      } else {
        return true
      }
    },
    validate () {
      let valid = true
      this.messageString = ''

      let keys = [
        [this.newForm.crm,'CRM field is required.'],
        [this.newForm.agency.name, 'Agency Name is required.'],
        [this.newForm.owner.street,'Address is required.'],
        [this.newForm.owner.city, 'City is required.'],
        [this.newForm.owner.state, 'State is required.'],
        [this.newForm.owner.zipcode, 'Zip is required.'],
        [this.newForm.owner.contact1, 'Contact 1 is required.'],
        [this.newForm.owner.contact2, 'Contact 2 is required.'],
        [this.newForm.owner.primary_phone, 'Phone is required.'],
        [this.newForm.owner.fax, 'Fax field is required.'],
        [this.newForm.operatingName, 'Agency Operating Name is required.'],
        [this.newForm.owner.name, 'Agent/Owner Name is required.'],
        [this.newForm.owner.cell_phone, 'Agent/Owner Cell Phone is required.'],
        [this.newForm.owner.email, 'Agent/Owner Email is required.'],
        [this.newForm.instructions, 'Other Instructions is required.'],
        [this.newForm.trainingContactName,'Training Contact Name is required.'],
        [this.newForm.trainingContactEmail,'Training Contact Email is required.']
      ]

      let self = this
      keys.forEach(function (item) {
        if (item[0].trim() === '') {
          valid = false;
          self.messageString += item[1] + '\n'
        }
      })

      let phoneKeys = [
        [this.newForm.owner.contact1, 'Please enter ten digits for contact 1.'],
        [this.newForm.owner.contact2, 'Please enter ten digits for contact 2.' ],
        [this.newForm.owner.primary_phone, 'Please enter ten digits for Phone.'],
        [this.newForm.owner.cell_phone, 'Please enter ten digits for Agent/Owner Cell Phone.'],
        [this.newForm.owner.fax, 'Please enter ten digits for fax.']
      ]
      phoneKeys.forEach(function (item) {
        if (item[0].length < 10) {
          valid = false
          self.messageString += item[1] + '\n'
        }
      })

      let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      if(this.newForm.owner.email.search("@") === -1 || this.newForm.trainingContactEmail.search("@") === -1) {
        valid = false
        this.messageString += 'Please enter a valid email. Email missing @' + '\n'
      } else if (!this.newForm.owner.email.match(emailFormat) || !this.newForm.trainingContactEmail.match(emailFormat)) {
        valid = false
        this.messageString += 'Please enter a valid email.' + '\n'
      }

      if (this.newForm.packageName === 'None') {
        valid = false
        this.messageString += 'Select a package level' + '\n'
      }
      if (this.newForm.sales_representative === 0) {
        valid = false
        this.messageString += 'Select a sales representative' + '\n'
      }
      if (this.newForm.referralSource === 0) {
        valid = false
        this.messageString += 'Select a source' + '\n'
      }

      if (valid === false) {
        this.messagePopup()
      }
      return valid
    },
    onSubmit () {
      if (this.validate()) {
        let data = this.newForm
        let self = this
        api.postRequest('/api/v1/agencies', data).then(
          (data) => {
            self.masterId = data.data.account
            window.open(config.applicationUrl('#/admin/backoffice/view/' + self.masterId), '_self', '')
          }
        ).catch(function (error) {
          let errorData = error.response.data['Improperly formatted request']
          self.messageString = ''
          for (var value in errorData) {
            self.messageString += errorData[value] + '\n'
          }
          self.messagePopup()
        })
      }
      }
    }
}
</script>

<style scoped>
.am-sign-up-form-inner-title-bar {
  height: 40px;
  background-color: #2777A3;
}
.am-sign-up-form-outer-title-bar {
  height: 40px;
  background-color: #2A95CC;
}
.am-sign-up-form-title {
  font-size: 14px;
  color: #FDFEFE;
  float: left;
  margin: 10px 0px 0px 15px;
}
.am-backoffice-signup {
  width: 900px;
  background-color: white;
  height: auto;
  overflow: hidden;
  margin-top: 20px;
}
.am-sign-up-form {
  padding: 20px;
  border: .5px solid gray;
}

.form-control {
  font-size: 12px;
  width: 55%;
}

.am-sign-up-form form {
  padding: 20px 10px 10px 40px;
  border: .5px solid lightgray;
}

.am-sign-up-form-ribbon-bottom {
  background-color: #2777A3;
  height: 35px;
}

.am-sign-up-form-save-button{
  background: transparent;
  border: none;
  margin-top: 3.5px;
}

.am-required:after {
  content: " *";
  color: red;
  font-size: 16px;
  float: right;
  margin: -35px 290px 0 0;
}

</style>
